// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2gDNz","content":"GlobalSearch_content__2Qs0h"};